<template>
    <CardShell>
        <CardHeader :hasData="false" heading="Help & Support"/>
        <div class="ph3 ph4-ns mt2 pb4">
            <div>
                Check out these 
                <router-link to="error-page" class="no-underline yellow "><span class="grow">frequently asked questions</span></router-link>
                to get quick answers to your questions. Or, reach out with a question below.
            </div>
            <textarea v-model="text" placeholder="How can we help you?" rows="8" class="pa3 mt2 w-100"></textarea>
            <TooliabaButton :enabled="text !== ''" class="mt4">Send</TooliabaButton>
        </div>
    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import CardHeader from '@/components/controls/CardHeader.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    data() {
        return {
            text: ''
        };
    },
    components: {
        CardShell,
        CardHeader,
        TooliabaButton
    }
};
</script>
